export default __webpack_public_path__ + "static/media/ro.51182fc9.svg";